// Module
var code = "<template element.ref=\"element\"> <div class=\"example\"> <div class=\"interactive-content ${fullWidth | toggle:'full-width'}\"><slot></slot></div> <div class=\"code-content\"> <div class=\"header\">${language}</div> <pre class=\"code-content\"><slot name=\"code\"></slot></pre> </div> </div> </template> ";
// Exports
module.exports = code;